export const book = Object.freeze({
    login:  '/login',
    logout:  '/logout',
    logoutOrg:  '/logout-organization',
    forgot: '/forgot',
    reset:  '/reset/:resetToken',
});
